import { render, staticRenderFns } from "./CoteacherEdit.vue?vue&type=template&id=b774dbae"
import script from "./CoteacherEdit.vue?vue&type=script&lang=js"
export * from "./CoteacherEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports